export default function NotificationCloseIco() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.54545 1L1 7.54545M1 1L7.54545 7.54545"
        stroke="#98A2B3"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
